import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import { useSelector } from 'react-redux';
import { globalActions } from 'redux/global/global.slice';
import { RootState, useAppDispatch } from 'redux/store';
import constant from 'utils/constant';

export const AuthWidget = (props) => {
    const showAuthPopup = useSelector((state: RootState) => state.global.showAuthPopup);
    const dispatch = useAppDispatch();

    return (
        <>
            {showAuthPopup && (
                <WidgetPopup
                    titlePopup={''}
                    widgetCode={WidgetCode.AuthWidget}
                    widgetProps={{ isOpenedOnPopup: true }}
                    onRedirect={() => {
                        dispatch(globalActions.setShowAuthPopup(false));
                    }}
                    onClose={() => {
                        dispatch(globalActions.setShowAuthPopup(false));
                    }}
                    pageCode={constant.PAGE_CODE.CHAT}
                    isFullScreen
                />
            )}
        </>
    );
};
